import { Organization, Professional, ResourceList } from '@domain/types';
import { EnvManager } from '@services/environment';
import { Http } from '@services/http/http.service';

const path = '/user';

// This function is only used in the launcher to get the connected user. It does not share the same headers/logic used in the HTTP client.
export async function getUser(): Promise<Response> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Auth-Mode': 'session',
  };
  return await fetch(`${EnvManager.getBaseUrlBackend()}/api/v1/users`, {
    method: 'GET',
    headers,
    credentials: 'include',
  });
}

export async function getUserIdentities(): Promise<ResourceList<Professional>> {
  return await Http.getInstance().get({ path: `${path}/identities` });
}

export async function getUserIntegrations(): Promise<ResourceList<Organization>> {
  return await Http.getInstance().get({ path: `${path}/integrations` });
}
